import React from 'react';
import styled from 'styled-components';

const Notice = styled.div<{ messageWidth: string }>`
	width: 100%;
	margin: auto;
	margin-top: 0.2em;
	.checkbox-container {
		float: left;
		clear: none;
		min-width: 22px;
		margin-top: .1em;
		margin-right: 0.5rem;
	}
	.notice-container {
		width: ${(props) => props.messageWidth};
		display: inline-block;
		margin: 0;
	}
	.regular-checkbox {
		-webkit-appearance: none;
		background-color: transparent;
		border: 2px solid #969696;
		border-radius: 4px;
		padding: 9px;
		width: 22px;
		height: 22px;
		display: inline-block;
		position: relative;
	}

	.regular-checkbox:checked:after {
		content: '\\2714';
		font-size: 14px;
		position: absolute;
		top: 3px;
		left: 4px;
		color: red;
	}
`;

interface Props {
	checked: boolean;
	message: any;
	onChange: () => void;
	messageWidth: string;
}

export const Checkbox: React.FC<Props> = (props: Props) => {
	return (
		<Notice messageWidth={props.messageWidth}>
			<div className={'checkbox-container'}>
				<input type="checkbox" id="checkbox-1-1" className="regular-checkbox" checked={props.checked} onChange={() => props.onChange()} />
			</div>
			<div className={'notice-container'}>{props.message}</div>
		</Notice>
	);
};
